/* eslint-disable */
import request from './helpers'

export function listClientMap(params) {
    return request({
        url: '/api/v1/client_info_map/search',
        method: 'get',
        params
    })
}

export function getDetail(id) {
    return request({
        url: '/api/v1/client_info_map/' + id,
        method: 'get'
    })
}

export function deleteClientMaps(ids) {
    return request({
        url: '/api/v1/client_info_map/batch/delete',
        method: 'delete',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            ids
        }
    })
}

export function updateClientMaps(data) {
    return request({
        url: '/api/v1/client_info_map/batch/update',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}
